import { PricingDetails } from "@db-models/pricing-db.model";

export const WEBSITE_PRICING_JSON: PricingDetails[] = [
  {
    chf: {
      monthly: { original_price: 29.90 },
      yearly: {
        // 12 * 29.90 * 0.9 = 322.92 → 323 / 12 = 26.91
        original_price: 26.91,
        saving_amount: 35.88, // 358.80 - 322.92
        saving_percent: 10
      },
    },
    eur: {
      monthly: { original_price: 29.90 },
      yearly: {
        // 12 * 29.90 * 0.9 = 322.92 → 323 / 12 = 26.91
        original_price: 26.91,
        saving_amount: 35.88, // 358.80 - 322.92
        saving_percent: 10
      },
    },
    usd: {
      monthly: { original_price: 35.00 },
      yearly: {
        // 12 * 35.00 * 0.9 = 378.00 → 378 / 12 = 31.50
        original_price: 31.50,
        saving_amount: 42.00, // 420.00 - 378.00
        saving_percent: 10
      },
    },
    gbp: {
      monthly: { original_price: 26.00 },
      yearly: {
        // 12 * 26.00 * 0.9 = 280.80 → 281 / 12 = 23.40
        original_price: 23.40,
        saving_amount: 31.20, // 312.00 - 280.80
        saving_percent: 10
      },
    },
    description: "Calenso basic",
    id: 103,
    included_bookings: 0,
    name: "basic",
    min_workers: 1,
    min_store: 1,
    min_group_appointment: 1,
    min_conference: 0,
    subscription_title: 'Basic',
    subscription_subtitle: {
      en_US: "The perfect starting point for GDPR-compalint online appointment scheduling.",
      de_CH: "Der perfekte Ausgangspunkt für die DSGVO-konforme Online-Terminplanung."
    },
    feature_list_title: {
      en_US: "Basis for scheduling your team",
      de_CH: "Basis für die Terminvereinbarung"
    },
    feature_list: {
      website: [
        {
          en_US: "1 User",
          de_CH: "1 Benutzer"
        },
        {
          en_US: "Online Calendar",
          de_CH: "Online-Kalender"
        },
        {
          en_US: "Unlimited Individual Appointments",
          de_CH: "Unbegrenzte Einzeltermine"
        },
        {
          en_US: "Group Bookings",
          de_CH: "Gruppenbuchungen"
        },
        {
          en_US: "Booking Page & Widget",
          de_CH: "Buchungsseite & Widget"
        },
        {
          en_US: "Appointment Confirmation & Reminders via Email",
          de_CH: "Terminbestätigung & -erinnerung per E-Mail"
        },
        {
          en_US: "Custom Forms",
          de_CH: "Individuelle Formulare"
        },
        {
          en_US: "Embed Booking on Your Website",
          de_CH: "Einbetten der Terminbuchung auf Ihrer Website"
        },
        {
          en_US: "Video consultation via Zoom",
          de_CH: "Video Beratung via Zoom"
        },
        {
          en_US: "Self-Service Support",
          de_CH: "Self-Service-Support"
        },
      ]
    },
  },
  {
    chf: {
      monthly: { original_price: 89.90 },
      // 12 * 89.90 * 0.9 = 970.92 → 971 / 12 = 80.91
      yearly: {
        original_price: 80.91,
        saving_amount: 107.88, // 1078.80 - 970.92
        saving_percent: 10
      }
    },
    eur: {
      monthly: { original_price: 89.90 },
      // 12 * 89.90 * 0.9 = 970.92 → 971 / 12 = 80.91
      yearly: {
        original_price: 80.91,
        saving_amount: 107.88,
        saving_percent: 10
      }
    },
    usd: {
      monthly: { original_price: 105.00 },
      // 12 * 105 * 0.9 = 1134 → 1134 / 12 = 94.50
      yearly: {
        original_price: 94.50,
        saving_amount: 126.00, // 1260 - 1134
        saving_percent: 10
      }
    },
    gbp: {
      monthly: { original_price: 79.00 },
      // 12 * 79 * 0.9 = 853.20 → 853.20 / 12 = 71.10
      yearly: {
        original_price: 71.10,
        saving_amount: 94.80, // 948 - 853.20
        saving_percent: 10
      }
    },
    description: "Calenso professional",
    id: 102,
    included_bookings: 0,
    name: "professional",
    min_workers: 3,
    min_store: 3,
    min_group_appointment: 10,
    min_conference: 0,
    subscription_title: 'Professional',
    subscription_subtitle: {
      en_US: "Ideal for businesses seeking personalized branding and dependable data protection.",
      de_CH: "Ideal für Unternehmen, die personalisierte Markenbildung und zuverlässigen Datenschutz suchen."
    },
    feature_list_title: {
      en_US: "Everything in Basic, plus",
      de_CH: "Alles in Basic, plus"
    },
    feature_list: {
      website: [
        {
          en_US: "Incl. 3 Users",
          de_CH: "Inkl. 3 Benutzer"
        },
        {
          en_US: "3 Branches",
          de_CH: "3 Filialen"
        },
        {
          en_US: "Custom Logo",
          de_CH: "Benutzerdefiniertes Logo"
        },
        {
          en_US: "Google Calendar, iCloud, Office 365, Exchange Synchronization",
          de_CH: "Google Kalender, iCloud, Office 365, Exchange Synchronisation"
        },
        {
          en_US: "Branches & Team Structure",
          de_CH: "Filialen- & Team-Struktur"
        },
        {
          en_US: "Analytics and Statistics",
          de_CH: "Analysen und Statistiken"
        },
        {
          en_US: "Video consultation via GoTo Meeting, Cisco Webex",
          de_CH: "Video Beratung via GoTo-Meeting, Cisco Webex"
        },
        {
          en_US: "Standard Support via Email (approx. 72 hrs)",
          de_CH: "Standard Support via E-Mail (ca. 72 Std.)"
        },
      ]
    },
  },
  {
    chf: {
      monthly: { original_price: 249.90 },
      yearly: {
        // 12 * 249.90 * 0.9 = 2698.92 → 2699 / 12 = 224.91
        original_price: 224.91,
        saving_amount: 299.88, // 2998.80 - 2698.92
        saving_percent: 10
      }
    },
    eur: {
      monthly: { original_price: 249.90 },
      yearly: {
        // 12 * 249.90 * 0.9 = 2698.92 → 2699 / 12 = 224.91
        original_price: 224.91,
        saving_amount: 299.88, // 2998.80 - 2698.92
        saving_percent: 10
      }
    },
    usd: {
      monthly: { original_price: 295.00 },
      yearly: {
        // 12 * 295 * 0.9 = 3186 → 3186 / 12 = 265.50
        original_price: 265.50,
        saving_amount: 354.00, // 3540 - 3186
        saving_percent: 10
      }
    },
    gbp: {
      monthly: { original_price: 219.00 },
      yearly: {
        // 12 * 219 * 0.9 = 2365.20 → 2365 / 12 = 197.10
        original_price: 197.10,
        saving_amount: 262.80, // 2628 - 2365.20
        saving_percent: 10
      }
    },
    description: "Calenso Business",
    id: 104,
    included_bookings: 0,
    name: "business",
    min_workers: 5,
    min_store: 5,
    min_group_appointment: 15,
    min_conference: 5,
    subscription_title: 'Business',
    subscription_subtitle: {
      en_US: "Tailored for companies aiming to digitize their appointment processes with a focus on reliable data protection and unique branding.",
      de_CH: "Zugeschnitten für Unternehmen, die ihre Terminprozesse digitalisieren möchten, mit Schwerpunkt auf zuverlässigem Datenschutz und einzigartigem Branding."
    },
    feature_list_title: {
      en_US: "Everything in Professional, plus",
      de_CH: "Alles in Professional, plus"
    },
    feature_list: {
      website: [
        {
          en_US: "Incl. 5 Users",
          de_CH: "Inkl. 5 Benutzer"
        },
        {
          en_US: "5 Branches",
          de_CH: "5 Filialen"
        },
        {
          en_US: "Conference Appointments (multiple hosts simultaneously)",
          de_CH: "Konferenztermine (mehrere Gastgeber gleichzeitig)"
        },
        {
          en_US: "Customizable Colors, Logo, and Branding",
          de_CH: "Anpassbare Farben, Logo und Branding"
        },
        {
          en_US: "Qualification Questions (Routing)",
          de_CH: "Qualifizierungsfragen (Routing)"
        },
        {
          en_US: "Workflows",
          de_CH: "Workflows"
        },
        {
          en_US: "Encrypted Customer and Appointment Data",
          de_CH: "Verschlüsselte Kunden- und Termindaten"
        },
        {
          en_US: "Mail Dispatch from Own SMTP Mail Server",
          de_CH: "Mailversand von eigenem SMTP-Mailserver"
        },
        {
          en_US: "Video consultation via Microsoft Teams",
          de_CH: "Video Beratung via Microsoft Teams"
        },
        {
          en_US: "Prioritized Support via Email with Callback Service (approx. 24 hrs)",
          de_CH: "Priorisierter Support via E-Mail mit Rückrufservice (ca. 24 Std.)"
        }
      ]
    }
  },
  {
    chf: {
      yearly: { original_price: 0, },
      monthly: { original_price: 0, }
    },
    eur: {
      yearly: { original_price: 0, },
      monthly: { original_price: 0, }
    },
    gbp: {
      yearly: { original_price: 0, },
      monthly: { original_price: 0, }
    },
    usd: {
      yearly: { original_price: 0, },
      monthly: { original_price: 0, }
    },
    description: "Calenso Enterprise",
    id: 105,
    included_bookings: 0,
    name: "enterprise",
    min_workers: 25,
    min_store: 10,
    min_group_appointment: 30,
    min_conference: 10,
    price_on_request: true,
    subscription_title: 'Enterprise',
    subscription_subtitle: {
      en_US: "Suited for companies requiring secure, scalable, and customizable software solutions for digitizing their appointment processes.",
      de_CH: "Geeignet für Unternehmen, die sichere, skalierbare und anpassbare Softwarelösungen für die Digitalisierung ihrer Terminprozesse benötigen."
    },
    feature_list_title: {
      en_US: "Everything in Business, plus",
      de_CH: "Alles in Business, plus"
    },
    feature_list: {
      website: [
        {
          en_US: "From 25 Users",
          de_CH: "Ab 25 Benutzer"
        },
        {
          en_US: "Corporate Design & Branding",
          de_CH: "Corporate Design & Branding"
        },
        {
          en_US: "Custom Booking Process",
          de_CH: "Individueller Buchungsprozess"
        },
        {
          en_US: "CRM & ERP Integrations (Salesforce, Dynamics, SAP, etc.)",
          de_CH: "CRM & ERP Integrationen (Salesforce, Dynamics, SAP etc.)"
        },
        {
          en_US: "Advanced Security Settings",
          de_CH: "Erweiterte Sicherheitseinstellungen"
        },
        {
          en_US: "Compliance with Audit Protocols",
          de_CH: "Compliance mit Audit-Protokollen"
        },
        {
          en_US: "Custom Roles and Permissions",
          de_CH: "Benutzerdefinierte Rollen und Berechtigungen"
        },
        {
          en_US: "Single Sign-On (SSO)",
          de_CH: "Single-Sign-on (SSO)"
        },
        {
          en_US: "Dynamic Availabilities (via Office365 or Microsoft Exchange Calendar)",
          de_CH: "Dynamische Verfügbarkeiten (via Office365 oder Microsoft Exchange Kalender)"
        },
        {
          en_US: "Personalized Account Manager (Prioritized Support according to SLA)",
          de_CH: "Personalisierter Account Manager (Priorisierter Support gemäss SLA)"
        },
        {
          en_US: "Video consultation via Unblu",
          de_CH: "Video Beratung via Unblu"
        },
        {
          en_US: "Automatic employee onboarding and offboarding with Microsoft Entra ID",
          de_CH: "Automatisches Mitarbeiter On- & Offboarding mit Microsoft Entra ID"
        },
      ]
    },
  }
]

export const MAX_LIMITE = 100000;
export const MIN_LIMITE = 1;
export const MIN_CONFERENCE_LIMITE = 0;

export const EXTRA_USER_COST = 5;
export const EXTRA_GROUP_APPOINTMENT_COST = 10;
export const EXTRA_STORE_COST = 10;
export const EXTRA_CONFERENCE_COST = 10;

export const SALES_TOKEN = '82e80dc8-9318-4be5-9be1-e8ef79859fca';